import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './stores/actionsList';
import { Route, Switch } from "react-router-dom";

import i18n from 'i18next';
import { siteConfig } from './variables/config'
import { changeUrlWithLng, checkPermission, getToken, getUserInfo, pathMaker } from './utils/useful'

import routes from './variables/routes'
import Header from './components/Header'
import Footer from './components/Footer';
import TabBar from './components/TabBar';
import NotifManager from './components/NotifManager';
import { addTopic, initSocket, socket } from './utils/socket.services';

import { io } from "socket.io-client";
import ProtectedRoute from './components/ProtectedRoute';
import { nanoid } from 'nanoid';
import store from './stores/storeConfig';
import HttpServices from './utils/Http.services';

// import Modal from './components/Modal'
// import './App.css';


class App extends React.Component {

    state = {
        lngRoute: '',
        showPage: false,
        ticketingId: nanoid(),
    }


    // socket = null
    componentDidMount() {
        this.checkUser()
        this.initConfig()
        initSocket()


    }




    componentDidUpdate(e) {


        if (e.history.action === "PUSH" && this.state.prevLoc !== e.history.location) {
            window.scrollTo(0, 0)
            this.props.actions.changeSetting('lastLocation', this.state.prevLoc)
            this.setState({ prevLoc: e.history.location })
        }

        if (this.props.user.loggedin !== e.user.loggedin && this.props.user.loggedin) {
            // this.checkUser()
        }


    }





    initConfig() {
        // this.props.actions.changeSetting('hideTabBar', false)

        // SET LANGNGUAGE
        let parent = this
        i18n.on('languageChanged', (lng) => {
            this.setState({ showPage: false })

            if (siteConfig.forceUrl) {
                changeUrlWithLng(lng)
            }
            this.props.actions.changeLanguage('language', lng)
            this.setState({ showPage: true })

        })
        this.setSize()

        window.addEventListener('resize', this.setSize)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setSize)

    }

    setSize = () => {
        let sizes = { isMobile: false, isTablet: false, isDesktop: false }
        let key = "isDesktop"
        let width = window.innerWidth
        if (width < 768 && width >= 576) {
            key = 'isTablet'
        }
        if (width < 576) {
            key = 'isMobile'
        }

        sizes[key] = true

        for (const [key, value] of Object.entries(sizes)) {
            this.props.actions.changeSetting(key, value)
        }

    }
    subscribeTicketing = (count, cb) => {
        console.log('subscribeTicketing', count)
        if (count <= 10) {

            setTimeout(() => {
                if (this.props.user?.info?.permissions) {
                    // console.log('this.props.user?.info?.permissionsobject', this.props.user?.info?.permissions)
                    if (checkPermission('trading.ticketing')) {
                        // if(socket.)
                        console.log('has admin.ticketing')
                        addTopic(this.state.ticketingId, 'ticketing', 'admin', null, this.updateData)
                        if (cb) {
                            cb()
                        }
                    }
                }
                else {
                    let ncount = count + 1
                    this.subscribeTicketing(ncount, cb)
                }
            }, 60);
        }

    }
    updateData = () => {

    }
    checkUser = (dontShowNotif) => {
        setTimeout(() => {
            console.log("CHECK USER")
            // console.log(this.props.user.loggedin)
            if (this.props.user.loggedin) {
                if (getToken()) {
                    getUserInfo((data, err, status) => {

                        // console.log(data)
                        // console.log(status)

                        if (status === 401) {
                            this.props.actions.logoutUser()
                        }
                        if (status === 200 && data) {
                            // console.log("DFF")
                            if (data.authorized) {

                                // console.log(data.user)
                                this.props.actions.setUser(data.user, null, true)
                                this.subscribeTicketing(0, () => {
                                    this.syncData()
                                    console.log('data.authorized')

                                })
                            } else {
                                this.props.actions.logoutUser()
                            }
                        } else {
                            this.props.actions.logoutUser()
                        }

                        if (err) {
                            if (!dontShowNotif) {
                                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.cantConnectToServer', description: '{{lang}}errors.checkYourInternetConnection' })
                            }
                            this.props.actions.setUser({}, null, true)
                            setTimeout(() => {
                                this.checkUser(true)
                            }, 10000);
                        }

                    })
                } else {
                    this.props.actions.logoutUser()
                }
            }
        }, 100);
    }

    syncData = () => {
        HttpServices.request('getTicketsCount', {}, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            console.log('fetchResuktic', fetchResult.count)
            store.dispatch(actions.addTicketsCount(fetchResult.count))
        })

    }
    render() {


        if (this.state.showPage) {
            return (
                <div className={"container-fluid default-theme m-0 p-0 w-100 " + (this.props.settings.isMobile ? 'mobile' : 'desktop')} >

                    <NotifManager>

                        <div className="d-flex w-100">

                            {this.props.settings.showTabBar && (
                                <TabBar />
                            )}


                            <div style={{ width: '100%', position: 'relative' }}>

                                {this.props.settings.showHeader && (
                                    <Header />
                                )}

                                <div className="w-100" style={{ minHeight: 'calc(100vh - 116px)' }} >
                                    <Switch>
                                        {routes.map((prop, index) => {
                                            if (prop.protected) {

                                                return (
                                                    <ProtectedRoute prop={prop} key={index} exact={prop.exact} path={(siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language) + prop.path} component={prop.component} />
                                                )
                                            } else {

                                                return (
                                                    <Route key={index}
                                                        exact={prop.exact}
                                                        path={(siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language) + prop.path}
                                                        component={prop.component}
                                                    />
                                                )
                                            }
                                        })}
                                    </Switch>
                                </div>

                                {this.props.settings.showFooter && (
                                    <Footer />
                                )}
                            </div>


                        </div>


                    </NotifManager>


                </div>
            )
        } else {
            return (<div></div>)
        }

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);